import {
  DEFAULT_AUTOMATED_TRIGGER,
  ONE_TIME_TRIGGER,
} from 'components/SegmentSelector/outreach-message-trigger-constants'

export const ONE_TIME = 'one-time'
export const AUTOMATED = 'automated'

export const OUTREACH_MESSAGE_TYPES = {
  [ONE_TIME]: {
    trigger: ONE_TIME_TRIGGER,
    title: 'One-Time',
    route: ONE_TIME,
    description: 'Messages sent once to a selection of your audience',
  },
  [AUTOMATED]: {
    trigger: DEFAULT_AUTOMATED_TRIGGER,
    title: 'Automated',
    route: AUTOMATED,
    description: 'Messages sent based on triggered actions',
  },
}
